"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roiCalculator = void 0;
var Models_1 = require("ContentTokens/Models");
var Text_1 = require("./Text");
exports.roiCalculator = {
    createToken: function () {
        return {
            type: "block",
            subType: "roiCalculator",
        };
    },
    createSlateJson: function () {
        return {
            type: Models_1.BlockType.ROICalculator,
            data: {
                slider: {
                    label: "Main variable",
                    increment: 1,
                    min: 1,
                    max: 100,
                    initialValue: 20,
                },
                inputs: {
                    A: {
                        label: "Example variable",
                        value: 80,
                        min: 0,
                        max: 1000,
                        prefix: "",
                        suffix: "",
                    },
                },
                roiResult: {
                    prefix: "$",
                    suffix: "",
                    formula: "{{slider}} * {{A}}",
                    label: {
                        plain: "",
                    },
                },
                title: {
                    plain: "",
                },
                description: {
                    plain: "",
                },
                variableCounter: 1,
                backgroundImageUrl: "",
                hasSelectedPreset: false,
            },
            children: [Text_1.text.createSlateJson()],
            isVoid: true,
        };
    },
};
